import Common from '../common'
var Js = Common('withdraw')
export default {
	name: 'withdraw',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width: 50
				},
				{
					key: 'count',
					label: '金额',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'trade_info',
					label: '说明',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: "status",
					label: '提现状态',
					application: ['编辑', '添加'],
					listType: 'normal',
					formatter: function(val, tests) {
						if (val.status < 0) {
							return '拒绝';
						} else {
							return ['同意', '待审核'][val.status - 1];
						}

					},
					componentName: 'sls-select',
					optionsName: 'withdrawOptions',
					filter_multiple: false,
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					header_search: {
						componentName: 'sls-select',
						optionsName: 'withdrawOptions',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请选择类型',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.status = val;
							} else {
								delete self.searchItem.status;
							};
							
						},
					}
				},
				{
					key: 'user_no',
					label: '用户NO',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入用户NO',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.user_no = val;
							} else {
								delete self.searchItem.user_no;
							};
							
						},
					},
				},
				{
					key: 'name',
					label: '用户姓名',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					formatter: function(val, tests) {
						return val.UserInfo.login_name ? val.UserInfo.login_name : '';
					},
				},


				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};
							
						},
					},
					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],
			// 按钮配置
			btn_info: [


				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					funcType: 'submit',
					position: 'list',
					text: function(data) {
						return '同意'
					},
					styleFunc: function(data) {
						if (data.withdraw_status == 0) {
							return 'background-color: #029A15'
						} else {
							return 'display: none'
						}
					},
					func: {
						apiName: function(self) {
							return "api_flowLogUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
									user_type: 1,
									status: 2
								},
								data: {
									status: 1,
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					funcType: 'submit',
					position: 'list',
					text: function(data) {
						return '拒绝'
					},
					func: {
						apiName: function(self) {
							return "api_flowLogUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
									user_type: 1,
									status: 2
								},
								data: {
									status: -1,
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					funcType: 'func',
					position: 'header',
					text: function(data) {
						return '导出'
					},
					func: {
						func: function(self) {
							window.location.href = 'https://api.shulxiang.com/api/public/index.php/api/v1/Project/Solely/outExcelWithdraw';
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
									user_type: 1,
									status: 2
								},
								data: {
									status: -1,
								}
							};
							return postData;
						}
					},
				},

			],

			searchItem: {
				type: 2,
				user_type: 1,
				behavior: 6,
				status: ['in', [1, -1, 2]],
			},
			startSearchItem: {
				type: 2,
				user_type: 1,
				behavior: 6,
				status: ['in', [1, -1, 2]],
			},
			optionData: {
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
				withdrawOptions: [{
						text: '拒绝',
						value: -1
					},
					{
						text: '待审核',
						value: 2
					},
					{
						text: '同意',
						value: 1
					},
				],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			}
		}

	},

	mounted() {
		const self = this;
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
		},

		outexcel() {
			const self = this;


		},

		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {
				UserInfo: {
					tableName: 'User',
					middleKey: 'user_no',
					key: 'user_no',
					condition: '=',
					searchItem: {
						status: 1
					},
					info: ['login_name'],
				},
				bank: {
					tableName: 'UserAddress',
					middleKey: 'relation_id',
					key: 'id',
					condition: '=',
					searchItem: {
						status: 1,
						user_type: 1
					},
				},
			};

			var res = await self.$$api_flowLogGet({
				data: postData
			});
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;

		}
		
	},


}



// WEBPACK FOOTER //
// ./src/views/flowLog/withdraw.js